export const depositories = [
  {
    label: "360 ONE DISTRIBUTION SERVICES LIMITED",
    value: "360 ONE DISTRIBUTION SERVICES LIMITED",
  },
  { label: "5PAISA CAPITAL LIMITED", value: "5PAISA CAPITAL LIMITED" },
  {
    label: "A C AGARWAL SHARE BROKERS PRIVATE LIMITED",
    value: "A C AGARWAL SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "A C CHOKSI SHARE BROKERS PRIVATE LIMITED",
    value: "A C CHOKSI SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "A K STOCKMART PRIVATE LIMITED",
    value: "A K STOCKMART PRIVATE LIMITED",
  },
  {
    label: "AARITYA BROKING PRIVATE LIMITED",
    value: "AARITYA BROKING PRIVATE LIMITED",
  },
  {
    label: "ABANS SECURITIES PRIVATE LIMITED",
    value: "ABANS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "ABHINANDAN STOCK BROKING PRIVATE LIMITED",
    value: "ABHINANDAN STOCK BROKING PRIVATE LIMITED",
  },
  { label: "ABHIPRA CAPITAL LIMITED", value: "ABHIPRA CAPITAL LIMITED" },
  { label: "ABIRA SECURITIES LIMITED", value: "ABIRA SECURITIES LIMITED" },
  {
    label: "ACEMONEY INTERMEDIARIES PRIVATE LIMITED",
    value: "ACEMONEY INTERMEDIARIES PRIVATE LIMITED",
  },
  {
    label: "ACHINTYA SECURITIES PRIVATE LIMITED",
    value: "ACHINTYA SECURITIES PRIVATE LIMITED",
  },
  {
    label: "ACML CAPITAL MARKETS LIMITED",
    value: "ACML CAPITAL MARKETS LIMITED",
  },
  {
    label: "ACUMEN CAPITAL MARKET (INDIA) LIMITED",
    value: "ACUMEN CAPITAL MARKET (INDIA) LIMITED",
  },
  {
    label: "ADINATH CAPITAL SERVICES LIMITED",
    value: "ADINATH CAPITAL SERVICES LIMITED",
  },
  {
    label: "ADINATH STOCK BROKING PRIVATE LIMITED",
    value: "ADINATH STOCK BROKING PRIVATE LIMITED",
  },
  { label: "ADITYA BIRLA MONEY LIMITED", value: "ADITYA BIRLA MONEY LIMITED" },
  {
    label: "ADROIT FINANCIAL SERVICES PRIVATE LIMITED",
    value: "ADROIT FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "ADWEALTH STOCK BROKING PRIVATE LIMITED",
    value: "ADWEALTH STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "AETRAM TRADES PRIVATE LIMITED",
    value: "AETRAM TRADES PRIVATE LIMITED",
  },
  {
    label: "AFFLUENCE SHARES AND STOCKS PRIVATE LIMITED",
    value: "AFFLUENCE SHARES AND STOCKS PRIVATE LIMITED",
  },
  {
    label: "AFN LANGRANA SHARE AND STOCK BROKERS PRIVATE LIMITED",
    value: "AFN LANGRANA SHARE AND STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "AGROY FINANCE AND INVESTMENT LIMITED",
    value: "AGROY FINANCE AND INVESTMENT LIMITED",
  },
  {
    label: "AIONION CAPITAL MARKET SERVICES PRIVATE LIMITED",
    value: "AIONION CAPITAL MARKET SERVICES PRIVATE LIMITED",
  },
  {
    label: "AIRAN FINSTOCKS PRIVATE LIMITED",
    value: "AIRAN FINSTOCKS PRIVATE LIMITED",
  },
  {
    label: "AJCON GLOBAL SERVICES LIMITED",
    value: "AJCON GLOBAL SERVICES LIMITED",
  },
  { label: "AJMERA ASSOCIATES LIMITED", value: "AJMERA ASSOCIATES LIMITED" },
  {
    label: "ALANKIT IMAGINATIONS LIMITED",
    value: "ALANKIT IMAGINATIONS LIMITED",
  },
  {
    label: "ALB STOCK BROKING PRIVATE LIMITED",
    value: "ALB STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "ALDAN INVESTMENTS PRIVATE LIMITED",
    value: "ALDAN INVESTMENTS PRIVATE LIMITED",
  },
  {
    label: "ALICE BLUE FINANCIAL SERVICES PRIVATE LIMITED",
    value: "ALICE BLUE FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "ALLEGRO SECURITIES PRIVATE LIMITED",
    value: "ALLEGRO SECURITIES PRIVATE LIMITED",
  },
  { label: "ALLWIN SECURITIES LIMITED", value: "ALLWIN SECURITIES LIMITED" },
  {
    label: "ALMONDZ GLOBAL SECURITIES LIMITED",
    value: "ALMONDZ GLOBAL SECURITIES LIMITED",
  },
  {
    label: "ALPHAGREP SECURITIES PRIVATE LIMITED",
    value: "ALPHAGREP SECURITIES PRIVATE LIMITED",
  },
  {
    label: "AMBALAL SHARES AND STOCKS PRIVATE LIMITED",
    value: "AMBALAL SHARES AND STOCKS PRIVATE LIMITED",
  },
  {
    label: "AMBIT CAPITAL PRIVATE LIMITED",
    value: "AMBIT CAPITAL PRIVATE LIMITED",
  },
  {
    label: "AMOL CAPITAL MARKETS PRIVATE LIMITED",
    value: "AMOL CAPITAL MARKETS PRIVATE LIMITED",
  },
  {
    label: "AMU SHARES & SECURITIES LIMITED",
    value: "AMU SHARES & SECURITIES LIMITED",
  },
  {
    label: "ANAND RATHI SHARE AND STOCK BROKERS LIMITED",
    value: "ANAND RATHI SHARE AND STOCK BROKERS LIMITED",
  },
  { label: "ANGEL ONE LIMITED", value: "ANGEL ONE LIMITED" },
  { label: "ANGEL SECURITIES LIMITED", value: "ANGEL SECURITIES LIMITED" },
  {
    label: "ANISHA FINCAP CONSULTANTS LIMITED",
    value: "ANISHA FINCAP CONSULTANTS LIMITED",
  },
  { label: "ANS PRIVATE LIMITED", value: "ANS PRIVATE LIMITED" },
  {
    label: "ANTIQUE STOCK BROKING LIMITED",
    value: "ANTIQUE STOCK BROKING LIMITED",
  },
  {
    label: "ANUSH SHARES & SECURITIES PRIVATE LIMITED",
    value: "ANUSH SHARES & SECURITIES PRIVATE LIMITED",
  },
  { label: "ARCH FINANCE LIMITED", value: "ARCH FINANCE LIMITED" },
  {
    label: "ARHAM SHARE PRIVATE LIMITED",
    value: "ARHAM SHARE PRIVATE LIMITED",
  },
  {
    label: "ARHAM WEALTH MANAGEMENT PRIVATE LIMITED",
    value: "ARHAM WEALTH MANAGEMENT PRIVATE LIMITED",
  },
  {
    label: "ARIHANT CAPITAL MARKETS LIMITED",
    value: "ARIHANT CAPITAL MARKETS LIMITED",
  },
  {
    label: "ARISTRO CAPITAL MARKETS LIMITED",
    value: "ARISTRO CAPITAL MARKETS LIMITED",
  },
  {
    label: "ARJ SECURITIES PRIVATE LIMITED",
    value: "ARJ SECURITIES PRIVATE LIMITED",
  },
  {
    label: "ARYA FIN-TRADE SERVICES INDIA PVT. LTD.",
    value: "ARYA FIN-TRADE SERVICES INDIA PVT. LTD.",
  },
  {
    label: "ARYAMAN CAPITAL MARKETS LIMITED",
    value: "ARYAMAN CAPITAL MARKETS LIMITED",
  },
  {
    label: "ASHIKA STOCK BROKING LIMITED",
    value: "ASHIKA STOCK BROKING LIMITED",
  },
  {
    label: "ASIAN MARKETS SECURITIES PRIVATE LIMITED",
    value: "ASIAN MARKETS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "ASIT C. MEHTA INVESTMENT INTERRMEDIATES LIMITED",
    value: "ASIT C. MEHTA INVESTMENT INTERRMEDIATES LIMITED",
  },
  {
    label: "ASNANI STOCK BROKER PRIVATE LIMITED",
    value: "ASNANI STOCK BROKER PRIVATE LIMITED",
  },
  {
    label: "ASTHA CREDIT AND SECURITIES PRIVATE LIMITED",
    value: "ASTHA CREDIT AND SECURITIES PRIVATE LIMITED",
  },
  {
    label: "ATS SHARE BROKERS PRIVATE LIMITED",
    value: "ATS SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "AUM CAPITAL MARKET PRIVATE LIMITED",
    value: "AUM CAPITAL MARKET PRIVATE LIMITED",
  },
  {
    label: "AUM SECURITIES PRIVATE LIMITED",
    value: "AUM SECURITIES PRIVATE LIMITED",
  },
  {
    label: "AUTUS SECURITIES PRIVATE LIMITED",
    value: "AUTUS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "AXIOM SHARE BROKING PRIVATE LIMITED",
    value: "AXIOM SHARE BROKING PRIVATE LIMITED",
  },
  { label: "AXIS BANK LIMITED", value: "AXIS BANK LIMITED" },
  { label: "AXIS SECURITIES LIMITED", value: "AXIS SECURITIES LIMITED" },
  {
    label: "B D SHAH SECURITIES LIMITED",
    value: "B D SHAH SECURITIES LIMITED",
  },
  {
    label: "B N RATHI SECURITIES LIMITED",
    value: "B N RATHI SECURITIES LIMITED",
  },
  {
    label: "B R JALAN SECURITIES PRIVATE LIMITED",
    value: "B R JALAN SECURITIES PRIVATE LIMITED",
  },
  {
    label: "BABA BHOOTHNATH TRADE AND COMMERCE LIMITED",
    value: "BABA BHOOTHNATH TRADE AND COMMERCE LIMITED",
  },
  {
    label: "BADJATE STOCK AND SHARES PRIVATE LIMITED",
    value: "BADJATE STOCK AND SHARES PRIVATE LIMITED",
  },
  {
    label: "BAHUBALI FINANCIAL SERVICES PRIVATE LIMITED",
    value: "BAHUBALI FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "BAJAJ FINANCIAL SECURITIES LIMITED",
    value: "BAJAJ FINANCIAL SECURITIES LIMITED",
  },
  { label: "BALAJI EQUITIES LIMITED", value: "BALAJI EQUITIES LIMITED" },
  {
    label: "BALJIT SECURITIES PRIVATE LIMITED",
    value: "BALJIT SECURITIES PRIVATE LIMITED",
  },
  { label: "BANK OF MAHARASHTRA", value: "BANK OF MAHARASHTRA" },
  {
    label: "BASAN EQUITY BROKING LIMITED",
    value: "BASAN EQUITY BROKING LIMITED",
  },
  {
    label: "BCB BROKERAGE PRIVATE LIMITED",
    value: "BCB BROKERAGE PRIVATE LIMITED",
  },
  { label: "BGSE FINANCIALS LIMITED", value: "BGSE FINANCIALS LIMITED" },
  {
    label: "BHAIJEE PORTFOLIO PRIVATE LIMITED",
    value: "BHAIJEE PORTFOLIO PRIVATE LIMITED",
  },
  {
    label: "BHANSALI VALUE CREATIONS PRIVATE LIMITED",
    value: "BHANSALI VALUE CREATIONS PRIVATE LIMITED",
  },
  {
    label: "BHARATHI SHARE BROKING PRIVATE LIMITED",
    value: "BHARATHI SHARE BROKING PRIVATE LIMITED",
  },
  {
    label: "BHH SECURITIES PRIVATE LIMITED",
    value: "BHH SECURITIES PRIVATE LIMITED",
  },
  {
    label: "BHOGILAL TRIKAMLAL SECURITIES PRIVATE LIMITED",
    value: "BHOGILAL TRIKAMLAL SECURITIES PRIVATE LIMITED",
  },
  {
    label: "BHUMIKA CONSULTANCY PRIVATE LIMITED",
    value: "BHUMIKA CONSULTANCY PRIVATE LIMITED",
  },
  {
    label: "BIGCAPITA SECURITIES PRIVATE LIMITED",
    value: "BIGCAPITA SECURITIES PRIVATE LIMITED",
  },
  {
    label: "BNK SECURITIES PRIVATE LIMITED",
    value: "BNK SECURITIES PRIVATE LIMITED",
  },
  {
    label: "BOB CAPITAL MARKETS LIMITED",
    value: "BOB CAPITAL MARKETS LIMITED",
  },
  { label: "BOI SHAREHOLDING LIMITED", value: "BOI SHAREHOLDING LIMITED" },
  { label: "BOI SHAREHOLDING LIMITED", value: "BOI SHAREHOLDING LIMITED" },
  { label: "BONANZA PORTFOLIO LIMITED", value: "BONANZA PORTFOLIO LIMITED" },
  {
    label: "BONDBAZAAR SECURITIES PRIVATE LIMITED",
    value: "BONDBAZAAR SECURITIES PRIVATE LIMITED",
  },
  {
    label: "BP EQUITIES PRIVATE LIMITED",
    value: "BP EQUITIES PRIVATE LIMITED",
  },
  {
    label: "BUGLEROCK CAPITAL PRIVATE LIMITED",
    value: "BUGLEROCK CAPITAL PRIVATE LIMITED",
  },
  {
    label: "C.R.KOTHARI AND SONS SHARES & STOCK BROKERS PRIVATE LIMITED",
    value: "C.R.KOTHARI AND SONS SHARES & STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "CAPSTOCKS AND SECURITIES (INDIA) PRIVATE LIMITED",
    value: "CAPSTOCKS AND SECURITIES (INDIA) PRIVATE LIMITED",
  },
  {
    label: "CAREGROWTH BROKING PRIVATE LIMITED",
    value: "CAREGROWTH BROKING PRIVATE LIMITED",
  },
  {
    label: "CD EQUISEARCH PRIVATE LIMITED",
    value: "CD EQUISEARCH PRIVATE LIMITED",
  },
  { label: "CENTRAL BANK OF INDIA", value: "CENTRAL BANK OF INDIA" },
  { label: "CENTRUM BROKING LIMITED", value: "CENTRUM BROKING LIMITED" },
  { label: "CENTRUM FINVERSE LIMITED", value: "CENTRUM FINVERSE LIMITED" },
  {
    label: "CHANDRAKALA BROKING SERVICES PRIVATE LIMITED",
    value: "CHANDRAKALA BROKING SERVICES PRIVATE LIMITED",
  },
  {
    label: "CHOICE EQUITY BROKING PRIVATE LIMITED",
    value: "CHOICE EQUITY BROKING PRIVATE LIMITED",
  },
  {
    label: "CHOLAMANDALAM SECURITIES LIMITED",
    value: "CHOLAMANDALAM SECURITIES LIMITED",
  },
  { label: "CHUKNOO SECURITIES LIMITED", value: "CHUKNOO SECURITIES LIMITED" },
  {
    label: "CHURIWALA SECURITIES PRIVATE LIMITED",
    value: "CHURIWALA SECURITIES PRIVATE LIMITED",
  },
  { label: "CIL SECURITIES LIMITED", value: "CIL SECURITIES LIMITED" },
  { label: "CITIBANK N.A.", value: "CITIBANK N.A." },
  { label: "CNB FINWIZ PRIVATE LIMITED", value: "CNB FINWIZ PRIVATE LIMITED" },
  {
    label: "COCHIN STOCK BROKERS LIMITED",
    value: "COCHIN STOCK BROKERS LIMITED",
  },
  { label: "COMFORT SECURITIES LIMITED", value: "COMFORT SECURITIES LIMITED" },
  {
    label: "COMPETENT FINMAN PRIVATE LIMITED",
    value: "COMPETENT FINMAN PRIVATE LIMITED",
  },
  {
    label: "COMPOSITE INVESTMENTS PRIVATE LIMITED",
    value: "COMPOSITE INVESTMENTS PRIVATE LIMITED",
  },
  {
    label: "CROSSEAS CAPITAL MARKETS PRIVATE LIMITED",
    value: "CROSSEAS CAPITAL MARKETS PRIVATE LIMITED",
  },
  {
    label: "CROWN CONSULTANTS PRIVATE LIMITED",
    value: "CROWN CONSULTANTS PRIVATE LIMITED",
  },
  {
    label: "CSE CAPITAL MARKETS PRIVATE LIMITED",
    value: "CSE CAPITAL MARKETS PRIVATE LIMITED",
  },
  {
    label: "D B (INTERNATIONAL) STOCK BROKERS LIMITED",
    value: "D B (INTERNATIONAL) STOCK BROKERS LIMITED",
  },
  {
    label: "D R SHARE & STOCK BROKERS PRIVATE LIMITED",
    value: "D R SHARE & STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "DAILY GONG FINANCIAL SERVICES LIMITED",
    value: "DAILY GONG FINANCIAL SERVICES LIMITED",
  },
  {
    label: "DALAL & BROACHA STOCK BROKING PVT. LTD",
    value: "DALAL & BROACHA STOCK BROKING PVT. LTD",
  },
  { label: "DBFS SECURITIES LIMITED", value: "DBFS SECURITIES LIMITED" },
  { label: "DBS BANK INDIA LIMITED", value: "DBS BANK INDIA LIMITED" },
  {
    label: "DEALMONEY COMMODITIES PRIVATE LIMITED",
    value: "DEALMONEY COMMODITIES PRIVATE LIMITED",
  },
  {
    label: "DEFINEDGE SECURITIES BROKING PRIVATE LIMITED",
    value: "DEFINEDGE SECURITIES BROKING PRIVATE LIMITED",
  },
  {
    label: "DELSTOX STOCKS AND SHARES LIMITED",
    value: "DELSTOX STOCKS AND SHARES LIMITED",
  },
  { label: "DEUTSCHE BANK AG", value: "DEUTSCHE BANK AG" },
  {
    label: "DHWAJA SHARES AND SECURITIES PRIVATE LIMITED",
    value: "DHWAJA SHARES AND SECURITIES PRIVATE LIMITED",
  },
  { label: "DIAMOND HANDS LLP", value: "DIAMOND HANDS LLP" },
  {
    label: "DINDAYAL BIYANI STOCK BROKERS LIMITED",
    value: "DINDAYAL BIYANI STOCK BROKERS LIMITED",
  },
  {
    label: "DIVYA CAPITAL ONE PRIVATE LIMITED",
    value: "DIVYA CAPITAL ONE PRIVATE LIMITED",
  },
  {
    label: "DYNA WEGMANS SECURITIES LIMITED",
    value: "DYNA WEGMANS SECURITIES LIMITED",
  },
  {
    label: "EAST INDIA SECURITIES LIMITED",
    value: "EAST INDIA SECURITIES LIMITED",
  },
  {
    label: "ECONO BROKING PRIVATE LIMITED",
    value: "ECONO BROKING PRIVATE LIMITED",
  },
  {
    label: "ELARA SECURITIES (INDIA) PRIVATE LIMITED",
    value: "ELARA SECURITIES (INDIA) PRIVATE LIMITED",
  },
  { label: "ELITE WEALTH LIMITED", value: "ELITE WEALTH LIMITED" },
  {
    label: "ELIXIR EQUITIES PRIVATE LIMITED",
    value: "ELIXIR EQUITIES PRIVATE LIMITED",
  },
  {
    label: "EMKAY GLOBAL FINANCIAL SERVICES LIMITED",
    value: "EMKAY GLOBAL FINANCIAL SERVICES LIMITED",
  },
  {
    label: "ENRICH FINANCIAL MARKET PRIVATE LIMITED",
    value: "ENRICH FINANCIAL MARKET PRIVATE LIMITED",
  },
  {
    label: "EQUIRUS SECURITIES PRIVATE LIMITED",
    value: "EQUIRUS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "EQUIRUS WEALTH PRIVATE LIMITED",
    value: "EQUIRUS WEALTH PRIVATE LIMITED",
  },
  {
    label: "ESTELLE SECURITIES PRIVATE LIMITED",
    value: "ESTELLE SECURITIES PRIVATE LIMITED",
  },
  {
    label: "EUREKA STOCK & SHARE BROKING SERVICES LIMITED",
    value: "EUREKA STOCK & SHARE BROKING SERVICES LIMITED",
  },
  {
    label: "EVERMORE STOCK BROKERS PRIVATE LIMITED",
    value: "EVERMORE STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "EXCLUSIVE SECURITIES LIMITED",
    value: "EXCLUSIVE SECURITIES LIMITED",
  },
  {
    label: "F R RATNAGAR AND COMPANY PRIVATE LIMITED",
    value: "F R RATNAGAR AND COMPANY PRIVATE LIMITED",
  },
  {
    label: "FAIR INTERMEDIATE INVESTMENT PRIVATE LIMITED",
    value: "FAIR INTERMEDIATE INVESTMENT PRIVATE LIMITED",
  },
  {
    label: "FARSIGHT SECURITIES LIMITED",
    value: "FARSIGHT SECURITIES LIMITED",
  },
  {
    label: "FAST CAPITAL MARKETS LIMITED",
    value: "FAST CAPITAL MARKETS LIMITED",
  },
  {
    label: "FE SECURITIES PRIVATE LIMITED",
    value: "FE SECURITIES PRIVATE LIMITED",
  },
  {
    label: "FEDERAL CAPITAL MARKETS LIMITED",
    value: "FEDERAL CAPITAL MARKETS LIMITED",
  },
  {
    label: "FINANCE MONITOR (INDIA) PRIVATE LIMITED",
    value: "FINANCE MONITOR (INDIA) PRIVATE LIMITED",
  },
  {
    label: "FINDOC INVESTMART PRIVATE LIMITED",
    value: "FINDOC INVESTMART PRIVATE LIMITED",
  },
  {
    label: "FINQUEST SECURITIES PRIVATE LIMITED",
    value: "FINQUEST SECURITIES PRIVATE LIMITED",
  },
  {
    label: "FINVASIA SECURITIES PRIVATE LIMITED",
    value: "FINVASIA SECURITIES PRIVATE LIMITED",
  },
  {
    label: "FINWIZARD TECHNOLOGY PRIVATE LIMITED",
    value: "FINWIZARD TECHNOLOGY PRIVATE LIMITED",
  },
  {
    label: "FIRSTOCK BROKING PRIVATE LIMITED",
    value: "FIRSTOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "FOCUS SHARES & SECURITIES PRIVATE LIMITED",
    value: "FOCUS SHARES & SECURITIES PRIVATE LIMITED",
  },
  {
    label: "FOCUS STOCK BROKERS LIMITED",
    value: "FOCUS STOCK BROKERS LIMITED",
  },
  {
    label: "FORT SHARE BROKING PRIVATE LIMITED",
    value: "FORT SHARE BROKING PRIVATE LIMITED",
  },
  {
    label: "FORTUNE CAPITAL SERVICES PRIVATE LIMITED",
    value: "FORTUNE CAPITAL SERVICES PRIVATE LIMITED",
  },
  { label: "FORTUNE FISCAL LIMITED", value: "FORTUNE FISCAL LIMITED" },
  {
    label: "FORTUNE WEALTH MANAGEMENT CO. INDIA (P) LIMITED",
    value: "FORTUNE WEALTH MANAGEMENT CO. INDIA (P) LIMITED",
  },
  {
    label: "FRR SHARES AND SECURITIES LIMITED",
    value: "FRR SHARES AND SECURITIES LIMITED",
  },
  {
    label: "FYERS SECURITIES PRIVATE LIMITED",
    value: "FYERS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "GAINN FINTECH PRIVATE LIMITED",
    value: "GAINN FINTECH PRIVATE LIMITED",
  },
  {
    label: "GANDHI SECURITIES AND INVESTMENT PVT LTD",
    value: "GANDHI SECURITIES AND INVESTMENT PVT LTD",
  },
  {
    label: "GANESH STOCKINVEST PRIVATE LIMITED",
    value: "GANESH STOCKINVEST PRIVATE LIMITED",
  },
  {
    label: "GANGANAGAR COMMODITY LIMITED",
    value: "GANGANAGAR COMMODITY LIMITED",
  },
  {
    label: "GANPATI FINSEC PRIVATE LIMITED",
    value: "GANPATI FINSEC PRIVATE LIMITED",
  },
  {
    label: "GARG SECURITIES PRIVATE LIMITED",
    value: "GARG SECURITIES PRIVATE LIMITED",
  },
  { label: "GEOJIT INVESTMENTS LIMITED", value: "GEOJIT INVESTMENTS LIMITED" },
  {
    label: "GEPL CAPITAL PRIVATE LIMITED",
    value: "GEPL CAPITAL PRIVATE LIMITED",
  },
  {
    label: "GHANSHYAM SHARES AND STOCK BROKERS PRIVATE LIMITED",
    value: "GHANSHYAM SHARES AND STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "GIRIRAJ STOCK BROKING PRIVATE LIMITED",
    value: "GIRIRAJ STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "GLOBALWORTH SECURITIES LIMITED",
    value: "GLOBALWORTH SECURITIES LIMITED",
  },
  {
    label: "GLOBE CAPITAL MARKET LIMITED",
    value: "GLOBE CAPITAL MARKET LIMITED",
  },
  {
    label: "GNG STOCK HOLDINGS PRIVATE LIMITED",
    value: "GNG STOCK HOLDINGS PRIVATE LIMITED",
  },
  {
    label: "GOLDMINE STOCKS PRIVATE LIMITED",
    value: "GOLDMINE STOCKS PRIVATE LIMITED",
  },
  {
    label: "GOODWILL WEALTH MANAGEMENT PRIVATE LIMITED",
    value: "GOODWILL WEALTH MANAGEMENT PRIVATE LIMITED",
  },
  {
    label: "GOPALJI BROKING PRIVATE LIMITED",
    value: "GOPALJI BROKING PRIVATE LIMITED",
  },
  { label: "GRD SECURITIES LIMITED", value: "GRD SECURITIES LIMITED" },
  {
    label: "GRESHMA SHARES & STOCKS LIMITED",
    value: "GRESHMA SHARES & STOCKS LIMITED",
  },
  {
    label: "GROWTH SECURITIES PRIVATE LIMITED",
    value: "GROWTH SECURITIES PRIVATE LIMITED",
  },
  {
    label: "GROWW INVEST TECH PRIVATE LIMITED",
    value: "GROWW INVEST TECH PRIVATE LIMITED",
  },
  { label: "GURUSTOX LIMITED", value: "GURUSTOX LIMITED" },
  {
    label: "GYANDEEP STOCKS PRIVATE LIMITED",
    value: "GYANDEEP STOCKS PRIVATE LIMITED",
  },
  {
    label: "HARDIK FINTRADE PRIVATE LIMITED",
    value: "HARDIK FINTRADE PRIVATE LIMITED",
  },
  { label: "HDFC BANK LIMITED", value: "HDFC BANK LIMITED" },
  {
    label: "HDFC BANK LIMITED (ERSTWHILE CENTURION BANK OF PUNJAB)",
    value: "HDFC BANK LIMITED (ERSTWHILE CENTURION BANK OF PUNJAB)",
  },
  { label: "HDFC SECURITIES LIMITED", value: "HDFC SECURITIES LIMITED" },
  {
    label: "HDFC SECURITIES LIMITED-DP86700",
    value: "HDFC SECURITIES LIMITED-DP86700",
  },
  {
    label: "HEM SECURITIES LIMITED - JAIPUR",
    value: "HEM SECURITIES LIMITED - JAIPUR",
  },
  {
    label: "HENSEX SECURITIES PRIVATE LIMITED",
    value: "HENSEX SECURITIES PRIVATE LIMITED",
  },
  {
    label: "HINDUSTAN TRADECOM PRIVATE LIMITED",
    value: "HINDUSTAN TRADECOM PRIVATE LIMITED",
  },
  {
    label: "HORIZON FINANCIAL CONSULTANTS PRIVATE LIMITED",
    value: "HORIZON FINANCIAL CONSULTANTS PRIVATE LIMITED",
  },
  {
    label: "HORNIC INVESTMENT PRIVATE LIMITED",
    value: "HORNIC INVESTMENT PRIVATE LIMITED",
  },
  {
    label: "HPMG SHARES AND SECURITIES PRIVATE LIMITED",
    value: "HPMG SHARES AND SECURITIES PRIVATE LIMITED",
  },
  {
    label: "HSB SECURITIES & EQUITIES LIMITED",
    value: "HSB SECURITIES & EQUITIES LIMITED",
  },
  { label: "ICICI BANK LIMITED", value: "ICICI BANK LIMITED" },
  {
    label: "ICICI BANK LIMITED -JAIPUR MAIN BRANCH",
    value: "ICICI BANK LIMITED -JAIPUR MAIN BRANCH",
  },
  { label: "IDBI BANK LIMITED", value: "IDBI BANK LIMITED" },
  {
    label: "IFCI FINANCIAL SERVICES LIMITED",
    value: "IFCI FINANCIAL SERVICES LIMITED",
  },
  {
    label: "IIFL CAPITAL SERVICES LIMITED",
    value: "IIFL CAPITAL SERVICES LIMITED",
  },
  {
    label: "IIFL CAPITAL SERVICES LIMITED",
    value: "IIFL CAPITAL SERVICES LIMITED",
  },
  {
    label: "IL&FS SECURITIES  SERVICES LIMITED",
    value: "IL&FS SECURITIES  SERVICES LIMITED",
  },
  {
    label: "INA STOCK BROKING CO. PRIVATE LIMITED",
    value: "INA STOCK BROKING CO. PRIVATE LIMITED",
  },
  { label: "INANI SECURITIES LIMITED", value: "INANI SECURITIES LIMITED" },
  {
    label: "INCRED CAPITAL WEALTH PORTFOLIO MANAGERS PRIVATE LIMITED",
    value: "INCRED CAPITAL WEALTH PORTFOLIO MANAGERS PRIVATE LIMITED",
  },
  {
    label: "INDBANK MERCHANT BANKING SERVICES LTD",
    value: "INDBANK MERCHANT BANKING SERVICES LTD",
  },
  {
    label: "INDBANK MERCHANT BANKING SERVICES LTD",
    value: "INDBANK MERCHANT BANKING SERVICES LTD",
  },
  {
    label: "INDIA ADVANTAGE SECURITIES PRIVATE LIMITED",
    value: "INDIA ADVANTAGE SECURITIES PRIVATE LIMITED",
  },
  {
    label: "INDIABULLS SECURITIES LIMITED",
    value: "INDIABULLS SECURITIES LIMITED",
  },
  {
    label: "INDIAN CLEARING CORPORATION LIMITED",
    value: "INDIAN CLEARING CORPORATION LIMITED",
  },
  { label: "INDIAN OVERSEAS BANK", value: "INDIAN OVERSEAS BANK" },
  {
    label: "INDIANIVESH SHARES & SECURITIES PRIVATE LIMITED",
    value: "INDIANIVESH SHARES & SECURITIES PRIVATE LIMITED",
  },
  {
    label: "INDIRA SECURITIES PRIVATE LIMITED",
    value: "INDIRA SECURITIES PRIVATE LIMITED",
  },
  { label: "INDMONEY PRIVATE LIMITED", value: "INDMONEY PRIVATE LIMITED" },
  {
    label: "INDO THAI SECURITIES LIMITED",
    value: "INDO THAI SECURITIES LIMITED",
  },
  {
    label: "INDUS SHARESHREE PRIVATE LIMITED",
    value: "INDUS SHARESHREE PRIVATE LIMITED",
  },
  { label: "INDUSIND BANK LIMITED", value: "INDUSIND BANK LIMITED" },
  {
    label: "INFINITY.COM FINANCIAL SECURITIES LIMITED",
    value: "INFINITY.COM FINANCIAL SECURITIES LIMITED",
  },
  {
    label: "INNOVATE SECURITIES PRIVATE LIMITED",
    value: "INNOVATE SECURITIES PRIVATE LIMITED",
  },
  {
    label: "INTEGRATED MASTER SECURITIES LIMITED",
    value: "INTEGRATED MASTER SECURITIES LIMITED",
  },
  {
    label: "INTELLECT STOCK BROKING LIMITED",
    value: "INTELLECT STOCK BROKING LIMITED",
  },
  {
    label: "INVENTURE GROWTH & SECURITIES LTD",
    value: "INVENTURE GROWTH & SECURITIES LTD",
  },
  {
    label: "INVESTERIA FINANCIAL SERVICES PRIVATE LIMITED",
    value: "INVESTERIA FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "INVESTSMART STOCK BROKERS PRIVATE LIMITED",
    value: "INVESTSMART STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "INVEXMART FINANCIAL SERVICES PRIVATE LIMITED",
    value: "INVEXMART FINANCIAL SERVICES PRIVATE LIMITED",
  },
  { label: "IRAGE BROKING SERVICES LLP", value: "IRAGE BROKING SERVICES LLP" },
  { label: "ISF SECURITIES LIMITED", value: "ISF SECURITIES LIMITED" },
  {
    label: "ISTAA FINSERV PRIVATE LIMITED",
    value: "ISTAA FINSERV PRIVATE LIMITED",
  },
  {
    label: "ITI SECURITIES BROKING LIMITED",
    value: "ITI SECURITIES BROKING LIMITED",
  },
  {
    label: "J G A SHAH SHARES BROKERS PRIVATE LIMITED",
    value: "J G A SHAH SHARES BROKERS PRIVATE LIMITED",
  },
  {
    label: "J G SHAH FINANCIAL CONSULTANTS PRIVATE LIMITED",
    value: "J G SHAH FINANCIAL CONSULTANTS PRIVATE LIMITED",
  },
  {
    label: "J L SHAH SECURITIES PRIVATE LIMITED",
    value: "J L SHAH SECURITIES PRIVATE LIMITED",
  },
  {
    label: "J P MORGAN CHASE BANK NATIONAL ASSOCIATION",
    value: "J P MORGAN CHASE BANK NATIONAL ASSOCIATION",
  },
  {
    label: "J V EQUITIES PRIVATE LIMITED",
    value: "J V EQUITIES PRIVATE LIMITED",
  },
  { label: "JAINAM BROKING LIMITED", value: "JAINAM BROKING LIMITED" },
  {
    label: "JAMBUWALA COMMODITIES PRIVATE LIMITED",
    value: "JAMBUWALA COMMODITIES PRIVATE LIMITED",
  },
  {
    label: "JAMNADAS VIRJI SHARES & STOCK BROKERS PRIVATE LIMITED",
    value: "JAMNADAS VIRJI SHARES & STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "JANATA SAHAKARI BANK LIMITED,PUNE",
    value: "JANATA SAHAKARI BANK LIMITED,PUNE",
  },
  {
    label: "JAVERI FISCAL SERVICES LIMITED",
    value: "JAVERI FISCAL SERVICES LIMITED",
  },
  {
    label: "JBS SECURITIES PRIVATE LIMITED",
    value: "JBS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "JEVIN STOCK BROKER PRIVATE LIMITED",
    value: "JEVIN STOCK BROKER PRIVATE LIMITED",
  },
  {
    label: "JHP SECURITIES PRIVATE LIMITED",
    value: "JHP SECURITIES PRIVATE LIMITED",
  },
  {
    label: "JKB FINANCIAL SERVICES LIMITED",
    value: "JKB FINANCIAL SERVICES LIMITED",
  },
  {
    label: "JM FINANCIAL SERVICES  LIMITED",
    value: "JM FINANCIAL SERVICES  LIMITED",
  },
  {
    label: "JOINDRE CAPITAL SERVICES LIMITED",
    value: "JOINDRE CAPITAL SERVICES LIMITED",
  },
  {
    label: "JRK STOCK BROKING PRIVATE LIMITED",
    value: "JRK STOCK BROKING PRIVATE LIMITED",
  },
  { label: "JSEL SECURITIES LIMITED", value: "JSEL SECURITIES LIMITED" },
  {
    label: "JUNOMONETA FINSOL PRIVATE LIMITED",
    value: "JUNOMONETA FINSOL PRIVATE LIMITED",
  },
  {
    label: "JYOTI BROKING PRIVATE LIMITED",
    value: "JYOTI BROKING PRIVATE LIMITED",
  },
  {
    label: "K M JAIN STOCK BROKERS PRIVATE LIMITED",
    value: "K M JAIN STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "KALPALABDHI FINANCIALS PRIVATE LIMITED",
    value: "KALPALABDHI FINANCIALS PRIVATE LIMITED",
  },
  {
    label: "KALPATARU MULTIPLIER LIMITED",
    value: "KALPATARU MULTIPLIER LIMITED",
  },
  {
    label: "KAMAL KUMAR JALAN SECURITIES PRIVATE LIMITED",
    value: "KAMAL KUMAR JALAN SECURITIES PRIVATE LIMITED",
  },
  {
    label: "KANTILAL CHHAGANLAL SECURITIES PRIVATE LIMITED",
    value: "KANTILAL CHHAGANLAL SECURITIES PRIVATE LIMITED",
  },
  {
    label: "KARUNA FINANCIAL SERVICES PRIVATE LIMITED",
    value: "KARUNA FINANCIAL SERVICES PRIVATE LIMITED",
  },
  { label: "KBS INDIA LIMITED", value: "KBS INDIA LIMITED" },
  {
    label: "KEDIA CAPITAL SERVICES PRIVATE LIMITED",
    value: "KEDIA CAPITAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "KEDIA SHARES AND STOCKS BROKERS LIMITED",
    value: "KEDIA SHARES AND STOCKS BROKERS LIMITED",
  },
  {
    label: "KELLTON SECURITIES PRIVATE LIMITED",
    value: "KELLTON SECURITIES PRIVATE LIMITED",
  },
  { label: "KEYNOTE CAPITALS LIMITED", value: "KEYNOTE CAPITALS LIMITED" },
  {
    label: "KHAJANCHI & GANDHI STOCK BROKING PRIVATE LIMITED",
    value: "KHAJANCHI & GANDHI STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "KHAMBATTA SECURITIES LIMITED",
    value: "KHAMBATTA SECURITIES LIMITED",
  },
  {
    label: "KHANDWALA SECURITIES LIMITED",
    value: "KHANDWALA SECURITIES LIMITED",
  },
  {
    label: "KJMC CAPITAL MARKET SERVICES LIMITED",
    value: "KJMC CAPITAL MARKET SERVICES LIMITED",
  },
  {
    label: "KLAY SECURITIES PRIVATE LIMITED",
    value: "KLAY SECURITIES PRIVATE LIMITED",
  },
  {
    label: "KMS STOCK BROKING COMPANY PRIVATE LIMITED",
    value: "KMS STOCK BROKING COMPANY PRIVATE LIMITED",
  },
  {
    label: "KNA SHARE BROKERS PRIVATE LIMITED",
    value: "KNA SHARE BROKERS PRIVATE LIMITED",
  },
  { label: "KOSAMATTAM FINANCE LIMITED", value: "KOSAMATTAM FINANCE LIMITED" },
  {
    label: "KOTAK MAHINDRA BANK LIMITED",
    value: "KOTAK MAHINDRA BANK LIMITED",
  },
  { label: "KOTAK SECURITIES LIMITED", value: "KOTAK SECURITIES LIMITED" },
  {
    label: "KRCHOKSEY SHARES AND SECURITIES PVT LTD",
    value: "KRCHOKSEY SHARES AND SECURITIES PVT LTD",
  },
  {
    label: "KSN CREDENCE COMMODITIES TRADING PRIVATE LIMITED",
    value: "KSN CREDENCE COMMODITIES TRADING PRIVATE LIMITED",
  },
  {
    label: "KUNVARJI FINSTOCK PRIVATE LIMITED",
    value: "KUNVARJI FINSTOCK PRIVATE LIMITED",
  },
  {
    label: "L F C SECURITIES PRIVATE LIMITED",
    value: "L F C SECURITIES PRIVATE LIMITED",
  },
  {
    label: "LAKSHMISHREE INVESTMENT AND SECURITIES LIMITED",
    value: "LAKSHMISHREE INVESTMENT AND SECURITIES LIMITED",
  },
  {
    label: "LALKAR SECURITIES PRIVATE LIMITED",
    value: "LALKAR SECURITIES PRIVATE LIMITED",
  },
  {
    label: "LATIN MANHARLAL SECURITIES PRIVATE LIMITED",
    value: "LATIN MANHARLAL SECURITIES PRIVATE LIMITED",
  },
  {
    label: "LGT CAPITAL MARKETS PRIVATE LIMITED",
    value: "LGT CAPITAL MARKETS PRIVATE LIMITED",
  },
  {
    label: "LIBORD BROKERAGE PRIVATE LIMITED",
    value: "LIBORD BROKERAGE PRIVATE LIMITED",
  },
  { label: "LKP SECURITIES LIMITED", value: "LKP SECURITIES LIMITED" },
  { label: "LSC SECURITIES LIMITED", value: "LSC SECURITIES LIMITED" },
  { label: "M PRASAD & CO. LIMITED", value: "M PRASAD & CO. LIMITED" },
  {
    label: "M R SHARE BROKING PRIVATE LIMITED",
    value: "M R SHARE BROKING PRIVATE LIMITED",
  },
  {
    label: "M S N SECURITIES PRIVATE LIMITED",
    value: "M S N SECURITIES PRIVATE LIMITED",
  },
  {
    label: "M. J. PATEL SHARE & STOCK BROKERS LIMITED",
    value: "M. J. PATEL SHARE & STOCK BROKERS LIMITED",
  },
  {
    label: "MAGNUM EQUITY BROKING LIMITED",
    value: "MAGNUM EQUITY BROKING LIMITED",
  },
  {
    label: "MAITRA COMMODITIES PRIVATE LIMITED",
    value: "MAITRA COMMODITIES PRIVATE LIMITED",
  },
  {
    label: "MALIRAM MAKHARIA FINSTOCK PRIVATE LIMITED",
    value: "MALIRAM MAKHARIA FINSTOCK PRIVATE LIMITED",
  },
  {
    label: "MANALI TRADING & HOLDINGS PRIVATE LIMITED",
    value: "MANALI TRADING & HOLDINGS PRIVATE LIMITED",
  },
  { label: "MANAPPURAM FINANCE LIMITED", value: "MANAPPURAM FINANCE LIMITED" },
  {
    label: "MANASHVI SECURITIES LIMITED",
    value: "MANASHVI SECURITIES LIMITED",
  },
  {
    label: "MANDOT SECURITIES PRIVATE LIMITED",
    value: "MANDOT SECURITIES PRIVATE LIMITED",
  },
  {
    label: "MANGAL KESHAV FINANCIAL SERVICES LLP",
    value: "MANGAL KESHAV FINANCIAL SERVICES LLP",
  },
  {
    label: "MANSI SHARE AND STOCK BROKING PRIVATE LIMITED",
    value: "MANSI SHARE AND STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "MANSUKH SECURITIES AND FINANCE LIMITED",
    value: "MANSUKH SECURITIES AND FINANCE LIMITED",
  },
  {
    label: "MANU STOCK BROKING PRIVATE LIMITED",
    value: "MANU STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "MANUBHAI MANGALDAS SECURITES PRIVATE LIMITED",
    value: "MANUBHAI MANGALDAS SECURITES PRIVATE LIMITED",
  },
  {
    label: "MARFATIA STOCK BROKING PRIVATE LIMITED",
    value: "MARFATIA STOCK BROKING PRIVATE LIMITED",
  },
  { label: "MARKET CREATORS LIMITED", value: "MARKET CREATORS LIMITED" },
  {
    label: "MARKET PULSE SECURITIES PRIVATE LIMITED",
    value: "MARKET PULSE SECURITIES PRIVATE LIMITED",
  },
  {
    label: "MARKET-HUB STOCK BROKING PRIVATE LIMITED",
    value: "MARKET-HUB STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "MARWADI SHARES AND FINANCE LIMITED",
    value: "MARWADI SHARES AND FINANCE LIMITED",
  },
  {
    label: "MASTER CAPITAL SERVICES LIMITED",
    value: "MASTER CAPITAL SERVICES LIMITED",
  },
  {
    label: "MAVERICK SHARE BROKERS PRIVATE LIMITED",
    value: "MAVERICK SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "MAX STOCK BROKING PRIVATE LIMITED",
    value: "MAX STOCK BROKING PRIVATE LIMITED",
  },
  { label: "MEHTA EQUITIES LIMITED", value: "MEHTA EQUITIES LIMITED" },
  {
    label: "MEHTA VAKIL AND COMPANY PRIVATE LIMITED",
    value: "MEHTA VAKIL AND COMPANY PRIVATE LIMITED",
  },
  {
    label: "MERFIN SHARES & STOCK BROKING PRIVATE LIMITED",
    value: "MERFIN SHARES & STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "MICROCURVES TRADING PRIVATE LIMITED",
    value: "MICROCURVES TRADING PRIVATE LIMITED",
  },
  {
    label: "MILI CONSULTANTS & INVESTMENT PRIVATE LIMITED",
    value: "MILI CONSULTANTS & INVESTMENT PRIVATE LIMITED",
  },
  {
    label: "MINDEX CAPITAL MARKET PVT LTD",
    value: "MINDEX CAPITAL MARKET PVT LTD",
  },
  {
    label: "MINTCAP BROKERS PRIVATE LIMITED",
    value: "MINTCAP BROKERS PRIVATE LIMITED",
  },
  {
    label: "MIRACLES FIN-TECH PRIVATE LIMITED",
    value: "MIRACLES FIN-TECH PRIVATE LIMITED",
  },
  {
    label: "MIRAE ASSET CAPITAL MARKETS (INDIA) PRIVATE LIMITED",
    value: "MIRAE ASSET CAPITAL MARKETS (INDIA) PRIVATE LIMITED",
  },
  {
    label: "MIRAE ASSET CAPITAL MARKETS (INDIA) PRIVATE LIMITED",
    value: "MIRAE ASSET CAPITAL MARKETS (INDIA) PRIVATE LIMITED",
  },
  {
    label: "MITHUN SECURITIES PRIVATE LIMITED",
    value: "MITHUN SECURITIES PRIVATE LIMITED",
  },
  {
    label: "MLB STOCK BROKING PRIVATE LIMITED",
    value: "MLB STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "MNM STOCK BROKING PRIVATE LIMITED",
    value: "MNM STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "MONARCH NETWORTH CAPITAL LIMITED",
    value: "MONARCH NETWORTH CAPITAL LIMITED",
  },
  {
    label: "MONEY LOGIX SECURITIES PRIVATE LIMITED",
    value: "MONEY LOGIX SECURITIES PRIVATE LIMITED",
  },
  {
    label: "MONEYBEE SECURITIES PRIVATE LIMITED",
    value: "MONEYBEE SECURITIES PRIVATE LIMITED",
  },
  {
    label: "MONEYCARE SECURITIES AND FINANCIAL SERVICES LIMITED",
    value: "MONEYCARE SECURITIES AND FINANCIAL SERVICES LIMITED",
  },
  {
    label: "MONEYLICIOUS SECURITIES PRIVATE LIMITED",
    value: "MONEYLICIOUS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "MONEYPALM BROKERS PRIVATE LIMITED",
    value: "MONEYPALM BROKERS PRIVATE LIMITED",
  },
  { label: "MONEYWISE FINVEST LIMITED", value: "MONEYWISE FINVEST LIMITED" },
  {
    label: "MOTILAL OSWAL FINANCIAL SERVICES LIMITED",
    value: "MOTILAL OSWAL FINANCIAL SERVICES LIMITED",
  },
  {
    label: "MOTILAL OSWAL FINANCIAL SERVICES LIMITED",
    value: "MOTILAL OSWAL FINANCIAL SERVICES LIMITED",
  },
  {
    label: "MOTISONS SHARES PRIVATE LIMITED",
    value: "MOTISONS SHARES PRIVATE LIMITED",
  },
  {
    label: "MSB E-TRADE SECURITIES LIMITED",
    value: "MSB E-TRADE SECURITIES LIMITED",
  },
  {
    label: "MSE FINANCIAL SERVICES LIMITED",
    value: "MSE FINANCIAL SERVICES LIMITED",
  },
  {
    label: "MUDRA OM SECURITIES PRIVATE LIMITED",
    value: "MUDRA OM SECURITIES PRIVATE LIMITED",
  },
  {
    label: "MULTIGAIN SECURITIES SERVICES PRIVATE LIMITED",
    value: "MULTIGAIN SECURITIES SERVICES PRIVATE LIMITED",
  },
  { label: "MULTIPLEX CAPITAL LIMITED", value: "MULTIPLEX CAPITAL LIMITED" },
  {
    label: "MUNOTH CAPITAL MARKET LIMITED",
    value: "MUNOTH CAPITAL MARKET LIMITED",
  },
  { label: "MUTHOOT FINCORP LIMITED", value: "MUTHOOT FINCORP LIMITED" },
  { label: "MUTHOOT SECURITIES LIMITED", value: "MUTHOOT SECURITIES LIMITED" },
  {
    label: "MUTHOOTTU MINI FINANCIERS LIMITED",
    value: "MUTHOOTTU MINI FINANCIERS LIMITED",
  },
  {
    label: "MY MONEY SECURITIES LIMITED",
    value: "MY MONEY SECURITIES LIMITED",
  },
  {
    label: "NARIMAN FINVEST PRIVATE LIMITED",
    value: "NARIMAN FINVEST PRIVATE LIMITED",
  },
  { label: "NAVIA MARKETS LIMITED", value: "NAVIA MARKETS LIMITED" },
  {
    label: "NAVJEEVAN EQUITY BROKING PRIVATE LIMITED",
    value: "NAVJEEVAN EQUITY BROKING PRIVATE LIMITED",
  },
  {
    label: "NAVKAR SHARE & STOCK BROKERS PRIVATE LIMITED",
    value: "NAVKAR SHARE & STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "NAYAN M VALA SECURITIES PRIVATE LIMITED",
    value: "NAYAN M VALA SECURITIES PRIVATE LIMITED",
  },
  {
    label: "NCJ SHARE & STOCK BROKERS LIMITED",
    value: "NCJ SHARE & STOCK BROKERS LIMITED",
  },
  {
    label: "NEO WEALTH MANAGEMENT PRIVATE LIMITED",
    value: "NEO WEALTH MANAGEMENT PRIVATE LIMITED",
  },
  {
    label: "NEW BERRY CAPITALS PRIVATE LIMITED",
    value: "NEW BERRY CAPITALS PRIVATE LIMITED",
  },
  {
    label: "NEW INDIA CO-OPERATIVE BANK LIMITED",
    value: "NEW INDIA CO-OPERATIVE BANK LIMITED",
  },
  {
    label: "NIDHI BROKING SERVICES PRIVATE LIMITED",
    value: "NIDHI BROKING SERVICES PRIVATE LIMITED",
  },
  {
    label: "NIKUNJ STOCK BROKERS LIMITED",
    value: "NIKUNJ STOCK BROKERS LIMITED",
  },
  {
    label: "NINE STAR BROKING PRIVATE LIMITED",
    value: "NINE STAR BROKING PRIVATE LIMITED",
  },
  {
    label: "NIRMAL BANG SECURITIES PRIVATE LIMITED",
    value: "NIRMAL BANG SECURITIES PRIVATE LIMITED",
  },
  {
    label: "NIRMAN SHARE BROKERS PRIVATE LIMITED",
    value: "NIRMAN SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "NJ INDIA INVEST PRIVATE LIMITED",
    value: "NJ INDIA INVEST PRIVATE LIMITED",
  },
  {
    label: "NNM SECURITIES PRIVATE LIMITED",
    value: "NNM SECURITIES PRIVATE LIMITED",
  },
  {
    label: "NORTHEAST BROKING SERVICES LIMITED",
    value: "NORTHEAST BROKING SERVICES LIMITED",
  },
  {
    label: "NU INVESTORS TECHNOLOGIES PVT LTD",
    value: "NU INVESTORS TECHNOLOGIES PVT LTD",
  },
  {
    label: "NUVAMA WEALTH AND INVESTMENT LIMITED",
    value: "NUVAMA WEALTH AND INVESTMENT LIMITED",
  },
  {
    label: "NVS BROKERAGE PRIVATE LIMITED",
    value: "NVS BROKERAGE PRIVATE LIMITED",
  },
  {
    label: "NX BLOCK TRADES PRIVATE LIMITED",
    value: "NX BLOCK TRADES PRIVATE LIMITED",
  },
  {
    label: "OHM STOCK BROKER PRIVATE LIMITED",
    value: "OHM STOCK BROKER PRIVATE LIMITED",
  },
  {
    label: "ORACLE SECURITIES PRIVATE LIMITED",
    value: "ORACLE SECURITIES PRIVATE LIMITED",
  },
  {
    label: "ORBIS FINANCIAL CORPORATION LIMITED",
    value: "ORBIS FINANCIAL CORPORATION LIMITED",
  },
  {
    label: "OSWAL SHARES & SECURITIES LIMITED",
    value: "OSWAL SHARES & SECURITIES LIMITED",
  },
  { label: "OUR BROKING SERVICES LLP", value: "OUR BROKING SERVICES LLP" },
  {
    label: "P SURYAKANT SHARE AND STOCK BROKERS PRIVATE LIMITED",
    value: "P SURYAKANT SHARE AND STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "PACE STOCK BROKING SERVICES PRIVATE LIMITED",
    value: "PACE STOCK BROKING SERVICES PRIVATE LIMITED",
  },
  {
    label: "PADAM TOWERS SECURITIES LIMITED",
    value: "PADAM TOWERS SECURITIES LIMITED",
  },
  {
    label: "PANKAJ MANGALDAS SECURITIES PRIVATE LIMITED",
    value: "PANKAJ MANGALDAS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "PARIM FINSERV PRIVATE LIMITED",
    value: "PARIM FINSERV PRIVATE LIMITED",
  },
  {
    label: "PARKER DERIVATIVES (INDIA) PRIVATE LIMITED",
    value: "PARKER DERIVATIVES (INDIA) PRIVATE LIMITED",
  },
  {
    label: "PARWATI CAPITAL MARKET PRIVATE LIMITED",
    value: "PARWATI CAPITAL MARKET PRIVATE LIMITED",
  },
  {
    label: "PASHUPATI CAPITAL SERVICES PRIVATE LIMITED",
    value: "PASHUPATI CAPITAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "PATERSON SECURITIES PRIVATE LIMITED",
    value: "PATERSON SECURITIES PRIVATE LIMITED",
  },
  { label: "PAYTM MONEY LIMITED", value: "PAYTM MONEY LIMITED" },
  { label: "PCS SECURITIES LIMITED", value: "PCS SECURITIES LIMITED" },
  {
    label: "PENTAD SECURITIES PRIVATE LIMITED",
    value: "PENTAD SECURITIES PRIVATE LIMITED",
  },
  {
    label: "PENTAGON STOCK BROKERS PVT LTD",
    value: "PENTAGON STOCK BROKERS PVT LTD",
  },
  {
    label: "PHILLIPCAPITAL (INDIA) PRIVATE LIMITED",
    value: "PHILLIPCAPITAL (INDIA) PRIVATE LIMITED",
  },
  {
    label: "PHONEPE WEALTH BROKING PRIVATE LIMITED",
    value: "PHONEPE WEALTH BROKING PRIVATE LIMITED",
  },
  {
    label: "PINNACLE FOREX AND SECURITIES PRIVATE LIMITED",
    value: "PINNACLE FOREX AND SECURITIES PRIVATE LIMITED",
  },
  {
    label: "PLUSWEALTH CAPITAL MANAGEMENT LLP",
    value: "PLUSWEALTH CAPITAL MANAGEMENT LLP",
  },
  {
    label: "POCKETFUL FINTECH CAPITAL PRIVATE LIMITED",
    value: "POCKETFUL FINTECH CAPITAL PRIVATE LIMITED",
  },
  {
    label: "PRABHAT FINANCIAL SERVICES LIMITED",
    value: "PRABHAT FINANCIAL SERVICES LIMITED",
  },
  {
    label: "PRABHUDAS LILLADHER PVT LTD",
    value: "PRABHUDAS LILLADHER PVT LTD",
  },
  {
    label: "PRABODH ARTHA WARDHINI PRIVATE LIMITED",
    value: "PRABODH ARTHA WARDHINI PRIVATE LIMITED",
  },
  {
    label: "PRAGYA SECURITIES PRIVATE LIMITED",
    value: "PRAGYA SECURITIES PRIVATE LIMITED",
  },
  {
    label: "PRAKASH K. SHAH SHARES & SECURITIES PRIVATE LIMITED",
    value: "PRAKASH K. SHAH SHARES & SECURITIES PRIVATE LIMITED",
  },
  {
    label: "PRARAMBH SECURITIES PRIVATE LIMITED",
    value: "PRARAMBH SECURITIES PRIVATE LIMITED",
  },
  {
    label: "PRB SECURITIES PRIVATE LIMITED",
    value: "PRB SECURITIES PRIVATE LIMITED",
  },
  {
    label: "PRITHVI FINMART PRIVATE LIMITED",
    value: "PRITHVI FINMART PRIVATE LIMITED",
  },
  {
    label: "PRL STOCK & SHARE BROKERS PRIVATE LIMITED",
    value: "PRL STOCK & SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "PROFICIENT EQUITIES PVT. LTD.",
    value: "PROFICIENT EQUITIES PVT. LTD.",
  },
  {
    label: "PROFITMART SECURITIES PRIVATE LIMITED",
    value: "PROFITMART SECURITIES PRIVATE LIMITED",
  },
  {
    label: "PROGRESSIVE SHARE BROKERS PRIVATE LIMITED",
    value: "PROGRESSIVE SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "PRRSAAR SAMPADA PRIVATE LIMITED",
    value: "PRRSAAR SAMPADA PRIVATE LIMITED",
  },
  {
    label: "PRUDENT CORPORATE ADVISORY SERVICES LIMITED",
    value: "PRUDENT CORPORATE ADVISORY SERVICES LIMITED",
  },
  { label: "PSB SECURITIES LIMITED", value: "PSB SECURITIES LIMITED" },
  {
    label: "PUMARTH CREDIT & CAPITAL LIMITED",
    value: "PUMARTH CREDIT & CAPITAL LIMITED",
  },
  {
    label: "PUNE E STOCK BROKING LIMITED",
    value: "PUNE E STOCK BROKING LIMITED",
  },
  { label: "PUNJAB NATIONAL BANK", value: "PUNJAB NATIONAL BANK" },
  { label: "PUNJAB NATIONAL BANK", value: "PUNJAB NATIONAL BANK" },
  {
    label: "PURE BROKING PRIVATE LIMITED",
    value: "PURE BROKING PRIVATE LIMITED",
  },
  { label: "QI BROKERAGE LLP", value: "QI BROKERAGE LLP" },
  { label: "QUEST SECURITIES LIMITED", value: "QUEST SECURITIES LIMITED" },
  {
    label: "R B K SHARE BROKING LIMITED",
    value: "R B K SHARE BROKING LIMITED",
  },
  {
    label: "R K STOCKHOLDING (P) LIMITED",
    value: "R K STOCKHOLDING (P) LIMITED",
  },
  {
    label: "R L P SECURITIES PRIVATE LIMITED",
    value: "R L P SECURITIES PRIVATE LIMITED",
  },
  {
    label: "R N PATWA SHARE & STOCK BROKERS (P) LTD",
    value: "R N PATWA SHARE & STOCK BROKERS (P) LTD",
  },
  {
    label: "R R NABAR & CO. SHARE BROKERS PRIVATE LIMITED",
    value: "R R NABAR & CO. SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "R R S SHARES & STOCK BROKERS PRIVATE LIMITED",
    value: "R R S SHARES & STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "R. WADIWALA SECURITIES PRIVATE LIMITED",
    value: "R. WADIWALA SECURITIES PRIVATE LIMITED",
  },
  {
    label: "RAEDAN CAPITAL PRIVATE LIMITED",
    value: "RAEDAN CAPITAL PRIVATE LIMITED",
  },
  {
    label: "RAGHUNANDAN CAPITAL PRIVATE LIMITED",
    value: "RAGHUNANDAN CAPITAL PRIVATE LIMITED",
  },
  {
    label: "RAIMA EQUITIES PRIVATE LIMITED",
    value: "RAIMA EQUITIES PRIVATE LIMITED",
  },
  {
    label: "RAINBOW SECURITIES PRIVATE LIMITED",
    value: "RAINBOW SECURITIES PRIVATE LIMITED",
  },
  {
    label: "RAJCHANDRA CAPITAL SERVICES PRIVATE LIMITED",
    value: "RAJCHANDRA CAPITAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "RAJENDRA MODI SHARE BROKERS PRIVATE LIMITED",
    value: "RAJENDRA MODI SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "RAJENDRA SHARE BROKING PRIVATE LIMITED",
    value: "RAJENDRA SHARE BROKING PRIVATE LIMITED",
  },
  {
    label: "RAJGUL SECURITIES PRIVATE LIMITED",
    value: "RAJGUL SECURITIES PRIVATE LIMITED",
  },
  {
    label: "RAJKOT NAGARIK SAHKARI BANK LIMITED",
    value: "RAJKOT NAGARIK SAHKARI BANK LIMITED",
  },
  {
    label: "RAJVI STOCK BROKING PRIVATE LIMITED",
    value: "RAJVI STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "RAMANIKLAL MOHANLAL CAPITAL MARKETS PVT LTD",
    value: "RAMANIKLAL MOHANLAL CAPITAL MARKETS PVT LTD",
  },
  {
    label: "RAMSNEHI VINIYOG PRIVATE LIMITED",
    value: "RAMSNEHI VINIYOG PRIVATE LIMITED",
  },
  {
    label: "RANGOLI TECHTRADERS PRIVATE LIMITED",
    value: "RANGOLI TECHTRADERS PRIVATE LIMITED",
  },
  {
    label: "RASHI EQUISEARCH PRIVATE LIMITED",
    value: "RASHI EQUISEARCH PRIVATE LIMITED",
  },
  { label: "RBL BANK LIMITED", value: "RBL BANK LIMITED" },
  {
    label: "RELIABLE STOCKS AND SHARES (INDIA) LIMITED",
    value: "RELIABLE STOCKS AND SHARES (INDIA) LIMITED",
  },
  {
    label: "RELIABLENIVESH SECURITIES PRIVATE LIMITED",
    value: "RELIABLENIVESH SECURITIES PRIVATE LIMITED",
  },
  {
    label: "RELIANCE SECURITIES LIMITED",
    value: "RELIANCE SECURITIES LIMITED",
  },
  {
    label: "RELIANCE SECURITIES LIMITED",
    value: "RELIANCE SECURITIES LIMITED",
  },
  { label: "RELIGARE BROKING LIMITED", value: "RELIGARE BROKING LIMITED" },
  {
    label: "RELITRADE STOCK BROKING PRIVATE LIMITED",
    value: "RELITRADE STOCK BROKING PRIVATE LIMITED",
  },
  { label: "RIKHAV SECURITIES LIMITED", value: "RIKHAV SECURITIES LIMITED" },
  {
    label: "RR EQUITY BROKERS PRIVATE LIMITED",
    value: "RR EQUITY BROKERS PRIVATE LIMITED",
  },
  {
    label: "RS WEALTH MANAGEMENT PRIVATE LIMITED",
    value: "RS WEALTH MANAGEMENT PRIVATE LIMITED",
  },
  {
    label: "RUDRA SHARES AND STOCK BROKERS LIMITED",
    value: "RUDRA SHARES AND STOCK BROKERS LIMITED",
  },
  {
    label: "S. P. JAIN SECURITIES PRIVATE LIMITED",
    value: "S. P. JAIN SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SAAKETA INVESTMENT SERVICES LIMITED",
    value: "SAAKETA INVESTMENT SERVICES LIMITED",
  },
  {
    label: "SACHDEVA STOCKS PRIVATE LIMITED",
    value: "SACHDEVA STOCKS PRIVATE LIMITED",
  },
  {
    label: "SAJAG SECURITIES PRIVATE LIMITED",
    value: "SAJAG SECURITIES PRIVATE LIMITED",
  },
  { label: "SAMCO SECURITIES LIMITED", value: "SAMCO SECURITIES LIMITED" },
  {
    label: "SAMURAI SECURITIES PRIVATE LIMITED",
    value: "SAMURAI SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SAMYAG BROKING PRIVATE LIMITED",
    value: "SAMYAG BROKING PRIVATE LIMITED",
  },
  {
    label: "SANGHAVI SAVLA STOCK BROKERS LIMITED",
    value: "SANGHAVI SAVLA STOCK BROKERS LIMITED",
  },
  {
    label: "SANKALP SHARE BROKERS PRIVATE LIMITED",
    value: "SANKALP SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "SAURASHTRA CAPITAL BROKING PRIVATE LIMITED",
    value: "SAURASHTRA CAPITAL BROKING PRIVATE LIMITED",
  },
  {
    label: "SB PATIL SECURITIES PRIVATE LIMITED",
    value: "SB PATIL SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SBI-SG GLOBAL SECURITIES SERVICES PRIVATE LIMITED",
    value: "SBI-SG GLOBAL SECURITIES SERVICES PRIVATE LIMITED",
  },
  { label: "SBICAP SECURITIES LIMITED", value: "SBICAP SECURITIES LIMITED" },
  { label: "SBICAP SECURITIES LIMITED", value: "SBICAP SECURITIES LIMITED" },
  {
    label: "SETHI FINMART PRIVATE LIMITED",
    value: "SETHI FINMART PRIVATE LIMITED",
  },
  {
    label: "SHARE INDIA SECURITIES LIMITED",
    value: "SHARE INDIA SECURITIES LIMITED",
  },
  { label: "SHAREKHAN LIMITED", value: "SHAREKHAN LIMITED" },
  {
    label: "SHAREWAY SECURITIES PRIVATE LIMITED",
    value: "SHAREWAY SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SHAREWEALTH SECURITIES LIMITED",
    value: "SHAREWEALTH SECURITIES LIMITED",
  },
  {
    label: "SHILPA STOCK BROKER PRIVATE LIMITED",
    value: "SHILPA STOCK BROKER PRIVATE LIMITED",
  },
  {
    label: "SHREE BAHUBALI STOCK BROKING LIMITED",
    value: "SHREE BAHUBALI STOCK BROKING LIMITED",
  },
  {
    label: "SHREE BALAJI MULTICOMMODITIES PRIVATE LIMITED",
    value: "SHREE BALAJI MULTICOMMODITIES PRIVATE LIMITED",
  },
  {
    label: "SHREE KANHA STOCK BROKING PRIVATE LIMITED",
    value: "SHREE KANHA STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "SHREE NAMAN SECURITIES AND FINANCE PRIVATE LIMITED",
    value: "SHREE NAMAN SECURITIES AND FINANCE PRIVATE LIMITED",
  },
  {
    label: "SHREE TISAI SECURITIES PRIVATE LIMITED",
    value: "SHREE TISAI SECURITIES PRIVATE LIMITED",
  },
  { label: "SHRENI SHARES LIMITED", value: "SHRENI SHARES LIMITED" },
  {
    label: "SHRI PARASRAM HOLDINGS PRIVATE LIMITED",
    value: "SHRI PARASRAM HOLDINGS PRIVATE LIMITED",
  },
  {
    label: "SHRI VENKATESH STOCK BROKER SERVICES INDIA PRIVATE LIMITED",
    value: "SHRI VENKATESH STOCK BROKER SERVICES INDIA PRIVATE LIMITED",
  },
  {
    label: "SHRIRAM INSIGHT SHARE BROKERS LIMITED",
    value: "SHRIRAM INSIGHT SHARE BROKERS LIMITED",
  },
  {
    label: "SHUBHAM STOCK BROKING SERVICES PRIVATE LIMITED",
    value: "SHUBHAM STOCK BROKING SERVICES PRIVATE LIMITED",
  },
  {
    label: "SIGNATUREGLOBAL COMTRADE PRIVATE LIMITED",
    value: "SIGNATUREGLOBAL COMTRADE PRIVATE LIMITED",
  },
  {
    label: "SILVER STREAM EQUITIES PRIVATE LIMITED",
    value: "SILVER STREAM EQUITIES PRIVATE LIMITED",
  },
  {
    label: "SKI CAPITAL SERVICES LIMITED",
    value: "SKI CAPITAL SERVICES LIMITED",
  },
  { label: "SKP SECURITIES LIMITED", value: "SKP SECURITIES LIMITED" },
  { label: "SKSE SECURITIES LIMITED", value: "SKSE SECURITIES LIMITED" },
  {
    label: "SKY COMMODITIES INDIA PRIVATE LIMITED",
    value: "SKY COMMODITIES INDIA PRIVATE LIMITED",
  },
  {
    label: "SMC GLOBAL SECURITIES LIMITED",
    value: "SMC GLOBAL SECURITIES LIMITED",
  },
  {
    label: "SMC GLOBAL SECURITIES LIMITED - MUMBAI MAIN",
    value: "SMC GLOBAL SECURITIES LIMITED - MUMBAI MAIN",
  },
  { label: "SMIFS LIMITED", value: "SMIFS LIMITED" },
  { label: "SPARK PWM PRIVATE LIMITED", value: "SPARK PWM PRIVATE LIMITED" },
  {
    label: "SPARK SECURITIES PRIVATE LIMITED",
    value: "SPARK SECURITIES PRIVATE LIMITED",
  },
  { label: "SPFL SECURITIES LIMITED", value: "SPFL SECURITIES LIMITED" },
  {
    label: "SPREAD X SECURITIES PRIVATE LIMITED",
    value: "SPREAD X SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SPS SHARE BROKERS PRIVATE LIMITED",
    value: "SPS SHARE BROKERS PRIVATE LIMITED",
  },
  {
    label: "SS CORPORATE SECURITIES LIMITED",
    value: "SS CORPORATE SECURITIES LIMITED",
  },
  {
    label: "SSJ FINANCE & SECURITIES PRIVATE LIMITED",
    value: "SSJ FINANCE & SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SSPL SECURITIES PRIVATE LIMITED",
    value: "SSPL SECURITIES PRIVATE LIMITED",
  },
  {
    label: "STABLE BROKING PRIVATE LIMITED",
    value: "STABLE BROKING PRIVATE LIMITED",
  },
  { label: "STANDARD CHARTERED BANK", value: "STANDARD CHARTERED BANK" },
  { label: "STANDARD CHARTERED BANK", value: "STANDARD CHARTERED BANK" },
  { label: "STANDARD CHARTERED BANK", value: "STANDARD CHARTERED BANK" },
  {
    label: "STANDARD SECURITIES & INVESTMENT INTERMEDIATES LTD",
    value: "STANDARD SECURITIES & INVESTMENT INTERMEDIATES LTD",
  },
  {
    label: "STEEL CITY SECURITIES LIMITED",
    value: "STEEL CITY SECURITIES LIMITED",
  },
  {
    label: "STELLAR SECURITIES PRIVATE LIMITTED",
    value: "STELLAR SECURITIES PRIVATE LIMITTED",
  },
  {
    label: "STOCK HOLDING CORPORATION OF INDIA LTD. ( INSTITUTIONAL )",
    value: "STOCK HOLDING CORPORATION OF INDIA LTD. ( INSTITUTIONAL )",
  },
  {
    label: "STOCK HOLDING CORPORATION OF INDIA LTD. (RETAIL)",
    value: "STOCK HOLDING CORPORATION OF INDIA LTD. (RETAIL)",
  },
  {
    label: "STOCKHOLDING SERVICES LIMITED",
    value: "STOCKHOLDING SERVICES LIMITED",
  },
  {
    label: "SUKESH JAIN SECURITIES PRIVATE LIMITED",
    value: "SUKESH JAIN SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SUNFLOWER BROKING PRIVATE LIMITED",
    value: "SUNFLOWER BROKING PRIVATE LIMITED",
  },
  {
    label: "SUNIDHI SECURITIES & FINANCE LIMITED",
    value: "SUNIDHI SECURITIES & FINANCE LIMITED",
  },
  { label: "SUNLIGHT BROKING LLP", value: "SUNLIGHT BROKING LLP" },
  {
    label: "SUNSHINE FINSEC & MERCANTILE LTD",
    value: "SUNSHINE FINSEC & MERCANTILE LTD",
  },
  {
    label: "SUNSHINE STOCK BROKING PRIVATE LIMITED",
    value: "SUNSHINE STOCK BROKING PRIVATE LIMITED",
  },
  {
    label: "SURESH RATHI SECURITIES PRIVATE LIMITED",
    value: "SURESH RATHI SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SUSHIL FINANCIAL SERVICES PRIVATE LIMITED",
    value: "SUSHIL FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "SVC CO-OPERATIVE BANK LIMITED",
    value: "SVC CO-OPERATIVE BANK LIMITED",
  },
  {
    label: "SVCM SECURITIES PRIVATE LIMITED",
    value: "SVCM SECURITIES PRIVATE LIMITED",
  },
  {
    label: "SVV SHARES & STOCK BROKERS PVT. LTD.",
    value: "SVV SHARES & STOCK BROKERS PVT. LTD.",
  },
  { label: "SW CAPITAL PRIVATE LIMITED", value: "SW CAPITAL PRIVATE LIMITED" },
  {
    label: "SWASTIKA INVESTMART LIMITED",
    value: "SWASTIKA INVESTMART LIMITED",
  },
  {
    label: "SYKES & RAY EQUITIES (INDIA) LIMITED",
    value: "SYKES & RAY EQUITIES (INDIA) LIMITED",
  },
  { label: "SYNDICATE BANK", value: "SYNDICATE BANK" },
  {
    label: "SYSTEMATIX SHARES AND STOCKS (INDIA) LIMITED",
    value: "SYSTEMATIX SHARES AND STOCKS (INDIA) LIMITED",
  },
  {
    label: "TATA FINTECH PRIVATE LIMITED",
    value: "TATA FINTECH PRIVATE LIMITED",
  },
  { label: "TATA SECURITIES LIMITED", value: "TATA SECURITIES LIMITED" },
  {
    label: "TAURUS CORPORATE ADVISORY SERVICES LIMITED",
    value: "TAURUS CORPORATE ADVISORY SERVICES LIMITED",
  },
  {
    label: "THE AKOLA JANATA COMMERCIAL CO-OPERATIVE BANK LIMITED, AKOLA",
    value: "THE AKOLA JANATA COMMERCIAL CO-OPERATIVE BANK LIMITED, AKOLA",
  },
  {
    label: "THE AKOLA URBAN COOPERATIVE BANK LIMITED, AKOLA",
    value: "THE AKOLA URBAN COOPERATIVE BANK LIMITED, AKOLA",
  },
  {
    label: "THE COSMOS COOPERATIVE BANK LIMITED",
    value: "THE COSMOS COOPERATIVE BANK LIMITED",
  },
  { label: "THE FEDERAL BANK LIMITED", value: "THE FEDERAL BANK LIMITED" },
  {
    label: "THE GREATER BOMBAY CO-OPERATIVE BANK LIMITED",
    value: "THE GREATER BOMBAY CO-OPERATIVE BANK LIMITED",
  },
  {
    label: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED",
    value: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED",
  },
  { label: "THE KARNATAKA BANK LIMITED", value: "THE KARNATAKA BANK LIMITED" },
  {
    label: "THE OMNISCIENT SECURITIES PRIVATE LIMITED",
    value: "THE OMNISCIENT SECURITIES PRIVATE LIMITED",
  },
  {
    label: "THE SARASWAT CO-OPERATIVE BANK LIMITED",
    value: "THE SARASWAT CO-OPERATIVE BANK LIMITED",
  },
  {
    label: "THE SOUTH INDIAN BANK LIMITED",
    value: "THE SOUTH INDIAN BANK LIMITED",
  },
  {
    label: "THINCREDBLU SECURITIES PRIVATE LIMITED",
    value: "THINCREDBLU SECURITIES PRIVATE LIMITED",
  },
  {
    label: "TIPSONS STOCK BROKERS PRIVATE LIMITED",
    value: "TIPSONS STOCK BROKERS PRIVATE LIMITED",
  },
  {
    label: "TORUS FINANCIAL MARKETS PRIVATE LIMITED",
    value: "TORUS FINANCIAL MARKETS PRIVATE LIMITED",
  },
  {
    label: "TRADEBULLS SECURITIES PRIVATE LIMITED",
    value: "TRADEBULLS SECURITIES PRIVATE LIMITED",
  },
  {
    label: "TRADEJINI FINANCIAL SERVICES PRIVATE LIMITED",
    value: "TRADEJINI FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "TRADESMART FINTECH SECURITIES LIMITED",
    value: "TRADESMART FINTECH SECURITIES LIMITED",
  },
  {
    label: "TRADESWIFT BROKING PRIVATE LIMITED",
    value: "TRADESWIFT BROKING PRIVATE LIMITED",
  },
  {
    label: "TRADEWELL SECURITIES LIMITED",
    value: "TRADEWELL SECURITIES LIMITED",
  },
  {
    label: "TRANSGLOBAL SECURITIES LIMITED",
    value: "TRANSGLOBAL SECURITIES LIMITED",
  },
  {
    label: "TRDEZ INVESTMENT PRIVATE LIMITED",
    value: "TRDEZ INVESTMENT PRIVATE LIMITED",
  },
  {
    label: "TRIVENI MANAGEMENT CONSULTANCY SERVICES LIMITED",
    value: "TRIVENI MANAGEMENT CONSULTANCY SERVICES LIMITED",
  },
  {
    label: "TRUST FINANCIAL CONSULTANCY SERVICES PRIVATE LIMITED",
    value: "TRUST FINANCIAL CONSULTANCY SERVICES PRIVATE LIMITED",
  },
  {
    label: "TRUSTED SHARES AND INVESTMENTS LIMITED",
    value: "TRUSTED SHARES AND INVESTMENTS LIMITED",
  },
  {
    label: "TRUSTLINE SECURITIES LIMITED",
    value: "TRUSTLINE SECURITIES LIMITED",
  },
  {
    label: "TWIN EARTH SECURITIES PRIVATE LIMITED",
    value: "TWIN EARTH SECURITIES PRIVATE LIMITED",
  },
  {
    label: "UAE EXCHANGE AND FINANCE LIMITED",
    value: "UAE EXCHANGE AND FINANCE LIMITED",
  },
  {
    label: "UNIFI CAPITAL PRIVATE LIMITED",
    value: "UNIFI CAPITAL PRIVATE LIMITED",
  },
  { label: "UNION BANK OF INDIA", value: "UNION BANK OF INDIA" },
  { label: "UNION BANK OF INDIA", value: "UNION BANK OF INDIA" },
  {
    label: "UNIQUE STOCKBRO PRIVATE LIMITED",
    value: "UNIQUE STOCKBRO PRIVATE LIMITED",
  },
  {
    label: "UPSTOX SECURITIES PRIVATE LIMITED",
    value: "UPSTOX SECURITIES PRIVATE LIMITED",
  },
  {
    label: "VACHANA INVESTMENTS PRIVATE LIMITED",
    value: "VACHANA INVESTMENTS PRIVATE LIMITED",
  },
  {
    label: "VARDHAMANGLOBAL SHARECOM PRIVATE LIMITED",
    value: "VARDHAMANGLOBAL SHARECOM PRIVATE LIMITED",
  },
  {
    label: "VARUN BROKING INDIA LIMITED",
    value: "VARUN BROKING INDIA LIMITED",
  },
  {
    label: "VCK SHARE & STOCK BROKING SERVICES LIMITED",
    value: "VCK SHARE & STOCK BROKING SERVICES LIMITED",
  },
  {
    label: "VEDIKA SECURITIES PRIVATE LIMITED",
    value: "VEDIKA SECURITIES PRIVATE LIMITED",
  },
  {
    label: "VEDIKA STOCK BROKING PRIVATE LIMITED",
    value: "VEDIKA STOCK BROKING PRIVATE LIMITED",
  },
  { label: "VENTURA SECURITIES LIMITED", value: "VENTURA SECURITIES LIMITED" },
  {
    label: "VIJETA BROKING INDIA PRIVATE LIMITED",
    value: "VIJETA BROKING INDIA PRIVATE LIMITED",
  },
  {
    label: "VIJIT GLOBAL SECURITIES PRIVATE LIMITED",
    value: "VIJIT GLOBAL SECURITIES PRIVATE LIMITED",
  },
  {
    label: "VISHWAS FINCAP SERVICES PRIVATE LIMITED",
    value: "VISHWAS FINCAP SERVICES PRIVATE LIMITED",
  },
  {
    label: "VRAMATH FINANCIAL SERVICES PRIVATE LIMITED",
    value: "VRAMATH FINANCIAL SERVICES PRIVATE LIMITED",
  },
  { label: "VSE STOCK SERVICES LIMITED", value: "VSE STOCK SERVICES LIMITED" },
  {
    label: "WALLFORT FINANCIAL SERVICES LIMITED",
    value: "WALLFORT FINANCIAL SERVICES LIMITED",
  },
  {
    label: "WAY2WEALTH BROKERS PRIVATE LIMITED",
    value: "WAY2WEALTH BROKERS PRIVATE LIMITED",
  },
  {
    label: "WAY2WEALTH BROKERS PRIVATE LIMITED",
    value: "WAY2WEALTH BROKERS PRIVATE LIMITED",
  },
  {
    label: "WEALTH DISCOVERY SECURITIES PRIVATE LIMITED",
    value: "WEALTH DISCOVERY SECURITIES PRIVATE LIMITED",
  },
  {
    label: "WEALTH FIRST PORTFOLIO MANAGERS LIMITED",
    value: "WEALTH FIRST PORTFOLIO MANAGERS LIMITED",
  },
  {
    label: "WEALTH INDIA FINANCIAL SERVICES PRIVATE LIMITED",
    value: "WEALTH INDIA FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "WEALTHSTREET FINANCIAL SERVICES PRIVATE LIMITED",
    value: "WEALTHSTREET FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "WEALTHYIN BROKING PRIVATE LIMITED",
    value: "WEALTHYIN BROKING PRIVATE LIMITED",
  },
  {
    label: "WELLWORTH SHARES AND STOCK BROKING LIMITED",
    value: "WELLWORTH SHARES AND STOCK BROKING LIMITED",
  },
  {
    label: "WIINANCE  FINANCIAL SERVICES PRIVATE LIMITED",
    value: "WIINANCE  FINANCIAL SERVICES PRIVATE LIMITED",
  },
  {
    label: "WOODSTOCK BROKING PRIVATE LIMITED",
    value: "WOODSTOCK BROKING PRIVATE LIMITED",
  },
  { label: "YES BANK LIMITED", value: "YES BANK LIMITED" },
  {
    label: "YES SECURITIES INDIA LIMITED",
    value: "YES SECURITIES INDIA LIMITED",
  },
  {
    label: "ZANSKAR SECURITIES PRIVATE LIMITED",
    value: "ZANSKAR SECURITIES PRIVATE LIMITED",
  },
  {
    label: "ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED",
    value: "ZEBU SHARE AND WEALTH MANAGEMENTS PRIVATE LIMITED",
  },
  { label: "ZEN SECURITIES LIMITED", value: "ZEN SECURITIES LIMITED" },
  { label: "ZERODHA BROKING LIMITED", value: "ZERODHA BROKING LIMITED" },
  { label: "ZUARI FINSERV LIMITED", value: "ZUARI FINSERV LIMITED" },
]
